<template>
  <div class="manage-main-box">
    <Bread :breadConfig="breadConfig" />
    <div class="eol-container-box">
      <div class="search-all-box">
        <a-form-model layout="inline" ref="ruleForm" :model="form">
          <a-form-model-item>
            <a-input style="width:160px" class="search-input" placeholder="请输入实践活动名称" v-model="form.name"></a-input>
          </a-form-model-item>
          <a-form-model-item>
            <a-select placeholder="请选择实践学期" style="width: 150px" class="multiple-select" dropdownClassName="multipleDrop" v-model="form.term">
              <a-select-option v-for="(item, index) in activityTerm" :key="index" :value="item.key">{{ item.value }}</a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item>
            <a-select placeholder="请选择实践课程" style="width: 150px" class="multiple-select" dropdownClassName="multipleDrop" v-model="form.course">
              <a-select-option v-for="(item, index) in trainCourse" :key="index" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item>
            <a-select show-search notFoundContent="暂无匹配班级" option-filter-prop="children" placeholder="请选择实践班级" style="width: 150px" class="multiple-select" dropdownClassName="multipleDrop" v-model="form.class_id">
              <a-select-option v-for="(item, index) in activityClass" :key="index" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item>
            <a-input style="width:160px" class="search-input" placeholder="请输入负责教师" v-model="form.teacher"></a-input>
          </a-form-model-item>

          <a-form-model-item>
            <a-button class="search-btn" type="primary" @click="onSearch">搜索</a-button>
            <a-button class="reset-btn" @click="resetForm">重置</a-button>
          </a-form-model-item>
        </a-form-model>
        <div class="right-option-box">
          <a-button class="option-btn" type="primary" @click="exportData">导出数据</a-button>
        </div>
      </div>
      <div class="table-all-box">
        <a-table :columns="columns" :data-source="tableData" @change="tableOnChange" rowKey="id" :bordered="false" size="small" :pagination="false">
          <template slot="operation" slot-scope="text, record">
            <a href="javascript:;" @click="toInfo(record.activity_id)" style="color: #125cfd;">活动详细分析</a>
          </template>
        </a-table>

        <a-pagination v-model="page" :total="total" :pageSize="size" @change="pageChange" />
      </div>

    </div>
    <!-- 下载进度 -->
    <a-spin :tip="`下载中 ${progress}% ...`" :spinning="loading">
      <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
    </a-spin>
  </div>
</template>
<script>
import Bread from "../../../components/school/Bread.vue"
import axios from "axios";
import services from "../../../assets/js/services";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      breadConfig: [
        { name: "活动数据统计" },
      ],
      school_code: localStorage.getItem("schoolCode"),
      tableData: [],
      total: 0,
      page: 1,
      size: 10,
      form: {
        name: undefined,
        teacher: undefined,
        course: undefined,
        term: undefined,
        class_id: undefined,
      },
      columns: [
        {
          title: "活动名称",
          dataIndex: "name",
        },
        {
          title: "实践课程",
          dataIndex: "course_name",
        },
        {
          title: "实践学期",
          dataIndex: "term_name",
        },
        {
          title: "负责教师",
          dataIndex: "teacher_names",
        },
        {
          title: "应参与活动人数",
          dataIndex: "num1",
          sorter: true
        },
        {
          title: "实际参与活动人数",
          dataIndex: "num2",
          sorter: true
        },
        {
          title: "活动参与率",
          dataIndex: "num3",
          sorter: true
        },
        {
          title: "完成活动人数",
          dataIndex: "num4",
          sorter: true
        },
        {
          title: "活动完成率",
          dataIndex: "num5",
          sorter: true
        },
        {
          title: "总分",
          dataIndex: "num6",
          sorter: true
        },
        {
          title: "平均分",
          dataIndex: "num7",
          sorter: true
        },
        {
          title: "得分率",
          dataIndex: "num8",
          sorter: true
        },
        {
          title: "最高分",
          dataIndex: "num9",
          sorter: true
        },
        {
          title: "最低分",
          dataIndex: "num10",
          sorter: true
        },
        {
          title: "操作",
          dataIndex: 'operation',
          width: 150,
          align: "center",
          scopedSlots: { customRender: 'operation' },
        },
      ],
      order: undefined, // 排序字段
      order_by: undefined, // 正序asc 倒叙desc
      progress: 0,
      loading: false,
    }
  },
  components: {
    Bread,
  },
  computed: {
    ...mapState({
      activityTerm: state => state.teachEvent.activityTerm,
      trainCourse: state => state.teachEvent.trainCourse,
      activityClass: state => state.teachEvent.activityClass,
    }),
  },
  mounted() {
    this.getActivityClass({
      page: 1, size: 999
    })
    this.getTrainCourse()
    this.getActivityTerm()
    this.getTableList()
  },
  methods: {
    ...mapActions(["getActivityTerm", "getTrainCourse", "getActivityClass"]),

    // 获取班级列表 表格数据
    getTableList() {
      let params = {
        page: this.page,
        size: this.size,
        active_name: this.form.name,
        term: this.form.term,
        course_id: this.form.course,
        teacher_name: this.form.teacher,
        class_id: this.form.class_id,
        order: this.order, // 排序字段
        order_by: this.order_by, // 正序asc 倒叙desc
      };
      services.getAnalyticsStatistics(params).then((res) => {
        if (res.code == "0000" && res.data) {
          this.tableData = res.data.items;
          this.total = res.data.total;
          // console.log(res.data)
        }
      });
    },
    //通过field 的值进行一个判断，然后在进行排序
    tableOnChange(p, f, s) {
      this.order_by = 'desc' // 正序asc 倒叙desc
      //第一个排序
      this.order_by = s.order == 'descend' ? 'desc' : s.order == 'ascend' ? 'asc' : '';
      if (s.field) {
        this.order = s.field
      }
      this.onSearch()
    },
    // 导出数据
    exportData() {
      let that = this
      if (that.tableData && that.tableData.length > 0) {
        that.loading = true
        axios({
          url: services.HOST + `/api/school/train/stat`,
          params: {
            actuve_name: this.form.name,
            term: this.form.term,
            course_id: this.form.course,
            teacher_name: this.form.teacher,
            class_id: this.form.class_id,
            order: this.order, // 排序字段
            order_by: this.order_by, // 正序asc 倒叙desc
            act: 'export' // 导出时传入
          },
          method: 'get',
          responseType: 'arraybuffer',
          onDownloadProgress: (progressEvent) => {
            if (progressEvent.lengthComputable) {
              that.progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
            }
          },
        }).then(res => {
          that.loading = false
          that.progress = 0
          if (res) {
            let newUrl = window.URL.createObjectURL(new Blob([res.data]));
            let type = 'xlsx'
            that.createUrlBlob(newUrl, `活动数据统计`, type)
          }
        }).catch(err => {
          that.loading = false
          that.progress = 0
          console.log(err)
        })
      } else {
        that.$message.error("暂无可导出的数据")
      }
    },
    // 文件流处理
    createUrlBlob(url, fileName, type) {
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.setAttribute('download', `${fileName}.${type}`);
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    },
    // 搜索按钮
    onSearch() {
      this.page = 1;
      this.getTableList();
    },
    // 分页点击事件
    pageChange(val) {
      this.page = val;
      this.getTableList();
    },
    resetForm() {
      this.form = {
        name: undefined,
        status: undefined,
        term: undefined,
        course: undefined,
        class: undefined,
        teacher: undefined
      };
      this.page = 1
      this.getTableList()
    },
    toInfo(id) {
      console.log(id);
      this.$router.push({
        path: `/${this.school_code}/school/activity/analytics`,
        query: {
          id: id
        }
      })

    }
  },

}
</script>

<style lang="less" scoped>
.eol-container-box {
  .event-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    .event-item {
      display: flex;
      margin-bottom: 32px;
      width: calc(50% - 22px);
      height: 210px;
      background: linear-gradient(0deg, #ffffff 0%, #ffffff 82%, #fff1f1 100%);
      border-radius: 0 4px 4px 0;
      overflow: hidden;
      position: relative;
      .event-status {
        width: 50px;
        height: 26px;
        background: #3f82f2;
        border-radius: 0px 0px 12px 0px;
        border: 1px solid #ffffff;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        &::before {
          content: "";
          width: 27px;
          height: 12px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: url("../../../assets/image/school/teach/course-open.png")
            no-repeat center/cover;
        }
        &.event-close {
          background: #7f8892;
          &::before {
            background: url("../../../assets/image/school/teach/course-close.png")
              no-repeat center/cover;
          }
        }
      }
      &:hover {
        .event-cover {
          .cover-img {
            transform: scale(1.1);
          }
        }
      }
      .event-cover {
        width: 280px;
        height: 100%;
        overflow: hidden;
        .cover-img {
          width: 100%;
          height: 100%;
          transition: all 0.3s;
        }
      }
      .event-text {
        flex: 1;
        padding: 20px 24px 24px;
        border: 1px solid #e3ebf3;
        border-left: none;
        border-radius: 0 4px 4px 0;
        overflow: hidden;
        div {
          font-weight: 400;
          font-size: 14px;
          color: #45464b;
          overflow: hidden;
          text-wrap: nowrap;
          text-overflow: ellipsis;
          margin-bottom: 5px;
        }
        span {
          color: #45464b;
        }
        .event-name {
          font-weight: bold;
          font-size: 16px;
          color: #333132;
          height: 40px;
          line-height: 20px;
          margin-bottom: 10px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; /* 限制文本为2行 */
          overflow: hidden;
          text-wrap: wrap;
          text-overflow: ellipsis;
        }
        .event-button {
          margin-top: 14px;
          display: flex;
          align-items: center;
          .button-item {
            padding: 4.5px 15px;
            background: #fff3f2;
            border-radius: 16px;
            border: 1px solid #cc9d9a;
            font-size: 14px;
            color: #a82822;
            &:not(:last-child) {
              margin-right: 16px;
            }
            cursor: pointer;
            &:hover {
              background: #ffe3e1;
            }
          }
        }
      }
    }
  }
}

.ant-form-inline .ant-form-item {
  margin-right: 12px;
}
.search-all-box .right-option-box {
  padding-top: 0;
}
@media screen and (max-width: 1280px) {
  .eol-container-box .event-list .event-item {
    width: 100%;
  }
}
@media screen and (max-width: 1800px) {
  .search-all-box .option-btn.ant-btn.ant-btn-primary {
    margin-left: 0;
  }
}
.delete-modal {
  font-weight: bold;
  font-size: 16px;
  color: #373536;
  text-align: center;
}
</style>